<!-- Register.vue -->
<template>
  <auth-form
    :val-error="ValError"
    :val-success="ValSuccess"
    :error-message="ErrorMessage"
    :success-message="SuccessMessage"
    :show-logging-in="showLoggingIn"
    action-text="Create account"
    link-text="Already have an account?"
    link-label="Login"
    link-to="/login"
    @submit="handleSubmit"
    @button-click="onLogInButton"
  >
    <template #title>
      <h2>Welcome to Quanspire</h2>
      <p>Create your account</p>
    </template>
    <template #form-fields>
      <label for="username">Username *</label>
      <input
        type="text"
        v-model="user.username"
        v-validate="'required'"
        name="username"
        placeholder="Enter your username"
        :class="{ 'is-invalid': submitted && errors.has('username') }"
      />
      <div v-if="submitted && errors.has('username')" class="invalid-feedback">
        {{ errors.first("username") }}
      </div>
      <label for="email">Email *</label>
      <input
        type="email"
        v-model="user.email"
        v-validate="'required'"
        name="email"
        placeholder="Enter your email"
        :class="{ 'is-invalid': submitted && errors.has('email') }"
      />
      <div v-if="submitted && errors.has('email')" class="invalid-feedback">
        {{ errors.first("email") }}
      </div>
      <label for="password">Password *</label>
      <input
        type="password"
        v-model="user.password"
        v-validate="{ required: true, min: 8 }"
        name="password"
        placeholder="Enter password"
        :class="{ 'is-invalid': submitted && errors.has('password') }"
      />
      <div v-if="submitted && errors.has('password')" class="invalid-feedback">
        {{ errors.first("password") }}
      </div>
      <label for="password_confirmation">Password confirmation *</label>
      <input
        type="password"
        v-model="user.password_confirmation"
        v-validate="{ required: true, min: 8 }"
        name="password_confirmation"
        placeholder="Confirm password"
        :class="{ 'is-invalid': submitted && errors.has('password_confirmation') }"
      />
      <div v-if="submitted && errors.has('password_confirmation')" class="invalid-feedback">
        {{ errors.first("password_confirmation") }}
      </div>
      <div class="terms-container">
        <label>
          <input
            type="checkbox"
            v-model="user.terms_condition"
            v-validate="{ required: true }"
            name="terms_condition"
            :class="{ 'is-invalid': submitted && errors.has('terms_condition') }"
          />
          <span>
            Accept <a @click.prevent="termsPage" href="#">Terms and Conditions</a>
          </span>
        </label>
      </div>
      <div v-if="submitted && errors.has('terms_condition')" class="invalid-feedback">
        {{ errors.first("terms_condition") }}
      </div>
    </template>
    <template #button-text>Create an account</template>
  </auth-form>
</template>

<script>
import AuthForm from "./AuthForm.vue"; // Adjust path as needed
import { mapState, mapActions } from "vuex";
import router from "../../router";

export default {
  components: { AuthForm },
  data() {
    return {
      user: {
        username: "",
        email: "",
        password: "",
        password_confirmation: "",
        terms_condition: false,
      },
      submitted: false,
      ValSuccess: false,
      ValError: false,
      ErrorMessage: "",
      SuccessMessage: "",
      showLoggingIn: false,
    };
  },
  computed: {
    ...mapState("authentication", ["status"]),
  },
  created() {
    document.title = "New Account | Quanspire";
  },
  methods: {
    onLogInButton() {
      this.showLoggingIn = true;
    },
    ...mapActions("authentication", ["register"]),
    async handleSubmit() {
      let validForm = false;
      this.submitted = true;
      await this.$validator.validate().then((valid) => {
        validForm = valid;
      });
      if (validForm) {
        await this.register(this.user);
        if (this.$store.state.alert.type === "alert-danger") {
          this.ErrorMessage = this.$store.state.alert.message;
          this.ValError = true;
          this.showLoggingIn = false;
        } else if (this.$store.state.alert.type === "alert-success") {
          this.SuccessMessage = this.$store.state.alert.message;
          this.ValSuccess = true;
          this.showLoggingIn = false;
          setTimeout(() => {
            router.push("/login");
          }, 5000);
        }
      } else {
        this.showLoggingIn = false;
      }
    },
    termsPage() {
      window.open("/Disclaimer", "_blank");
    },
  },
};
</script>

<style scoped>
.terms-container label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.terms-container input {
  width: 16px;
  height: 16px;
  accent-color: #007bff;
}

.terms-container a {
  color: #1345f2;
  text-decoration: none;
  font-weight: bold;
  transition: color 0.3s ease;
}

.terms-container a:hover {
  color: #173086;
}
</style>